'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$33() {
  this.bi5 = null;
  this.bi3 = null;
  this.bi4 = false;
  this.bi1 = null;
  this.bi2 = false;
  this.bi6 = false;
  this.bi7 = false;
  this.bi5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$33 as $c_Lpresto_PrestoRouter$$anon$33 };
$p = $c_Lpresto_PrestoRouter$$anon$33.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$33;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$33() {
}
export { $h_Lpresto_PrestoRouter$$anon$33 as $h_Lpresto_PrestoRouter$$anon$33 };
$h_Lpresto_PrestoRouter$$anon$33.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.bi5;
});
$p.t = (function() {
  if ((!this.bi4)) {
    this.bi3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bi4 = true;
  }
  return this.bi3;
});
$p.ag = (function() {
  if ((!this.bi2)) {
    this.bi1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bi2 = true;
  }
  return this.bi1;
});
$p.v = (function() {
  if ((!this.bi7)) {
    this.bi6 = false;
    this.bi7 = true;
  }
  return this.bi6;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$33 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$33, "presto.PrestoRouter$$anon$33", ({
  O7: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$33 as $d_Lpresto_PrestoRouter$$anon$33 };
//# sourceMappingURL=presto.-Presto-Router$$anon$33.js.map
